import { BasicStore, DetailedStore, DetailedStoreWithDistance } from './interfaces';

export const sortStoresByName = <T extends { readonly name?: string }>(
  stores: ReadonlyArray<T>,
  locale: string
): ReadonlyArray<T> => {
  return [...stores].sort((a, b) =>
    (a.name ?? '').localeCompare(b.name ?? '', locale, { sensitivity: 'base' })
  );
};

export const getInitialSortedStores = (
  stores: ReadonlyArray<BasicStore>,
  locale: string,
  limit: number = 10
): ReadonlyArray<BasicStore> => {
  return sortStoresByName(stores, locale).slice(0, limit);
};

export const getSortedInitialDetailedStores = async (
  allStores: ReadonlyArray<BasicStore>,
  locale: string,
  getStoresByIds: (storeIds: Array<string>) => Promise<ReadonlyArray<DetailedStore>>,
  limit: number = 10
): Promise<ReadonlyArray<DetailedStoreWithDistance>> => {
  const topStores = getInitialSortedStores(allStores, locale, limit);
  const topStoreIds = topStores.map((store) => store.code);

  if (topStoreIds.length === 0) {
    return [];
  }

  const detailedStores = await getStoresByIds(topStoreIds);

  const initialDetailedStores = detailedStores.map((store) => ({
    ...store,
    distance: null
  }));

  return sortStoresByName<DetailedStoreWithDistance>(initialDetailedStores, locale);
};
